module.exports = __webpack_public_path__ + "static/media/Magic Bricks Bird Tree House1.1202e4fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Magic Bricks Bird Tree House1.jpg
// module id = 165
// module chunks = 0